<template>
<pre v-html="code"></pre>  
</template>
<script>
import hljs from 'highlight.js'

export default {
  
    props: {
        attribute: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        code() {
            const headers = this.attribute.value.map((header) => {
                return `'${header}'`
            })
            
            return hljs.highlight(`
// config/cors.php
'allowed_headers' => [
  ${headers}
]
`, {language: 'php'}).value
        }
    }

}
</script>